import {SHAPE_PART_ID, SHAPE_TYPE} from "../constants";
import sqftShapeManager from "../components/canvas/store/sqftShapeManager";
import Polygon from "../components/canvas/core/shapes/layouts/polygon";
import {getAreaByShoelaceFormula} from "./sqftHelper";
import Wall from "../components/canvas/core/shapes/wall";
import workspaceControllers from "../components/canvas/store/workspaceControllers";
import {getCountertopPartNames} from "./shapeHelper";
import workspace from "../components/canvas/core/workspace";

export const enableFreeDrawMode = () => {

}

export const disableFreeDrawMode = () => {

}

export const createShapeFromFreeDrawPoints = (preparedPoints, shapeCenter) => {
  const [countertopPartName] = getCountertopPartNames();
  const shapeId = createShapeFromPoints(
    preparedPoints,
    countertopPartName,
    false,
    shapeCenter,
    true,
    null,
    {},
    {
      minimumShapeArea: 25,
      maximumShapeArea: 100000,
      maximumLineDistance: 1000,
    }
  );
  return workspace.getShapeById(shapeId);
}

/**
 * @param pointCords array
 * @param partId string
 * @param isClonePointRequired boolean
 * @param historyPosition
 * @param canPointsBeMoved
 * @param fromLayout
 * @param shapeParams
 * @param shapeCreationParams
 */
export const createShapeFromPoints = (
  pointCords,
  partId = SHAPE_PART_ID.seamPiece,
  isClonePointRequired = false,
  historyPosition = null,
  canPointsBeMoved = false,
  fromLayout = null,
  shapeParams = {},
  shapeCreationParams = {}
) => {
  let polygonLines = new Polygon(pointCords, isClonePointRequired, canPointsBeMoved);
  let polygonArea = getAreaByShoelaceFormula(polygonLines);
  if (polygonArea < 0) {
    //create counterclockwise shape
    polygonLines = new Polygon(pointCords.reverse(), isClonePointRequired, canPointsBeMoved);
    polygonArea = getAreaByShoelaceFormula(polygonLines);
  }

  if (shapeCreationParams.minimumShapeArea && polygonArea < shapeCreationParams.minimumShapeArea) {
    console.log("polygon area is too small");
    console.log("polygon area", polygonArea);
    console.log("minimum polygon Area", shapeCreationParams.minimumShapeArea);
    return null
  }
  if (shapeCreationParams.maximumShapeArea && polygonArea > shapeCreationParams.maximumShapeArea) {
    console.log("polygon area is too big");
    console.log("polygon area", polygonArea);
    console.log("maximum shape area", shapeCreationParams.maximumShapeArea);
    return null
  }
  if (shapeCreationParams.maximumLineDistance) {
    for (const polygonLine of polygonLines) {
      if (polygonLine.getLineDistance() > shapeCreationParams.maximumLineDistance) {
        console.log("polygon line is too big");
        console.log("polygon line distance", polygonLine.getLineDistance());
        console.log("maximum line Distance", shapeCreationParams.maximumLineDistance);
        return null
      }
    }
  }

  return sqftShapeManager.addShape(
    polygonLines, SHAPE_TYPE.polygon, historyPosition, partId, fromLayout, shapeParams
  );
};

/**
 *
 * @param points {array}
 * @param centerPoint {object}
 * @param lockedAngleStep
 */
export const createWallFromPointsV2 = (points, centerPoint, lockedAngleStep) => {
  const wall = new Wall(points, centerPoint, lockedAngleStep);
  workspaceControllers.walls.addResource(wall);
  return wall
}

/**
 *
 * @param points array
 */
export const createShapeFromCorePoints = (points) => {
  void points;
}

/**
 *
 * @param points array
 */
export const createPolygonFromCorePoints = (points) => {
  void points;
  //return new SQFTShapeFigure(points);
}
